import { isEmpty } from "lodash";
import { number, quote } from "../../config/constants";
import { updateUserEngagement } from "./engagement.service";

/**
 * Creates a payload object with project and user details.
 * @author Bhavana
 */
export const createPayload = (project, userId) => {
  if (!project) return null;
  const payload = {
    projectId: project?.projectId,
    selectedUserId: project?.UserId,
    ProjectEngagement: project?.ProjectAllocation,
    Allocation: project?.Allocation,
    WorkCategoryId: project?.WorkCategoryId,
  };
  return payload;
};

/**
 * Validates allocation inputs for a project and updates error states if validation fails.
 *@author Bhavana
 */
export const validateInputsHelper = (allocation, setError, setIsSaveDisabled) => {
  if (isEmpty(allocation)) {
    return;
  }
  const totalBlockAllocation = allocation.reduce((sum, val) => sum + Number(val), number.ZERO);
  const overAllocation = number.HUNDRED - totalBlockAllocation;
  if (totalBlockAllocation < number.HUNDRED) {
    setError(quote.SUM_OF_BLOCK_CANNOT_FALL + Math.abs(overAllocation) + "%");
    setIsSaveDisabled(true);
  } else if (totalBlockAllocation > number.HUNDRED) {
    setError(quote.SUM_OF_BLOCK_CANNOT_EXCEED + Math.abs(overAllocation) + "%");
    setIsSaveDisabled(true);
  } else if (totalBlockAllocation === number.HUNDRED) {
    setError("");
  }
};

export const options = ["All Projects", "Non-billed Projects", "Billed Projects"];

export const handleUserEngagementUpdate = async (updatedProject, userId) => {
  const payload = createPayload(updatedProject, userId);
  await updateUserEngagement(payload);
};
